export default "__VITE_ASSET__C_zC1fk9__"